import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { apis, hooks, models } from '@vote4dance/judging-sdk';
import { RegistrationTeamStatus } from '@vote4dance/judging-types';
import { Badge, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
var StreamHandler = apis.streaming.StreamHandler;
var Stream = hooks.streams.Stream;
var CompetitionRegistrationSource = models.registration.CompetitionRegistrationSource;
const { Text } = Typography;
export const useRegistrationNavMenuItemState = (props) => {
    const { event, competitions, defaultCompetitionId } = props;
    const [registrations] = Stream(event ? CompetitionRegistrationSource(event.competition_id) : undefined);
    const [summaryCount, setSummaryCount] = useState(0);
    const [totalCheckins, setTotalCheckins] = useState(() => ({}));
    const competitionIds = useMemo(() => { var _a; return (_a = competitions === null || competitions === void 0 ? void 0 : competitions.map(comp => comp.competition_id).join(',')) !== null && _a !== void 0 ? _a : ''; }, [competitions]);
    const trackedCompetitions = useMemo(() => competitions !== null && competitions !== void 0 ? competitions : [], [competitionIds]);
    const onReports = useCallback((competition_id, list) => {
        setTotalCheckins(prev => {
            const updated = { ...prev, [competition_id]: list || [] };
            const count = Object.values(updated).reduce((curr, entries) => {
                return curr + entries.filter(entry => [RegistrationTeamStatus.Created, RegistrationTeamStatus.Signed].includes(entry.registration_status)).length;
            }, 0);
            setSummaryCount(count);
            return updated;
        });
    }, [setSummaryCount]);
    useEffect(() => {
        if (trackedCompetitions.length === 0) {
            return;
        }
        const unsubscribeList = trackedCompetitions.map(competition => StreamHandler.get().subscribe(CompetitionRegistrationSource(competition.competition_id).url, (data) => {
            onReports(competition.competition_id, data);
        }));
        return () => {
            unsubscribeList.forEach(unsubscribe => {
                if (typeof unsubscribe === 'function')
                    unsubscribe();
            });
        };
    }, [trackedCompetitions, onReports]);
    useEffect(() => {
        if (event) {
            onReports(event.competition_id, registrations ? registrations : []);
        }
    }, [event === null || event === void 0 ? void 0 : event.competition_id, registrations, onReports]);
    const fallbackCompetitionId = defaultCompetitionId !== null && defaultCompetitionId !== void 0 ? defaultCompetitionId : event === null || event === void 0 ? void 0 : event.competition_id;
    const registrationPath = fallbackCompetitionId ? `comp/${fallbackCompetitionId}/registration` : 'registration';
    const label = summaryCount > 0 ? (React.createElement(NavLink, { to: registrationPath },
        React.createElement(Badge, { count: summaryCount, offset: [25, 10] },
            React.createElement(Text, { strong: true }, _T('registration.plural'))))) : (React.createElement(NavLink, { to: registrationPath }, _T('registration.plural')));
    return { label, count: summaryCount };
};
export const RegistrationNavMenuItem = (props) => {
    const { label } = useRegistrationNavMenuItemState(props);
    return React.createElement(React.Fragment, null, label);
};
